import { FC } from 'react';

export const CheckoutInfoBanner: FC = () => (
    <aside className="rounded-2xl border border-blue-300 bg-blue-50 px-5 py-4 text-blue-950 sm:px-6 dark:border-blue-900/60 dark:bg-blue-950/30 dark:text-blue-100">
        <h2 className="text-lg font-semibold">
            Оплата і доставка — між вами та продавцем
        </h2>
        <p className="mt-1 text-sm leading-relaxed text-blue-900/80 sm:text-base dark:text-blue-100/80">
            CartOn не приймає оплату та не здійснює доставку товарів. Після
            оформлення замовлення ви узгоджуєте оплату й передачу напряму з
            продавцем.
        </p>
    </aside>
);
